module.exports = __webpack_public_path__ + "static/lo-lifes-left-5d0076fe86c7bf29157e570ffd363f55.jpg";